<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <div class="container-fluid p-4">
      <span class="pageSteps card-styling" style="margin-top: 125px">
        <p style="font-weight: 300; font-style: normal">Dashboard</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-weight: 300; font-style: normal">Postagens</p>

        <img
          style="margin: 0 17px"
          :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
          alt=""
        />
        <p style="font-style: normal; font-weight: 500">Nova Postagem</p>
      </span>
      <div class="card-styling" style="margin-top: 32px">
        <StepProgress
          :mySteps="mystep"
          :currentStep="currentStep"
          @checkCurrentStep="checkCurrentStep"
        />

        <form
          class="d-flex flex-column w-100 align-items-center justify-content-between"
        >
          <div class="w-100" v-show="step === 0">
            <span>
              <h3
                style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 34px;
                  color: var(--grey-medium);
                "
              >
                Escolha a conta da loja para publicação
              </h3>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Nós iremos fazer a publicação na conta do instagram da loja
                selecionada nesta etapa
              </p>
            </span>
            <InputSearch @onUpdate="(value) => getStoreByName(value)" />
            <!-- <div
              class="d-flex align-items-center justify-content-center w-100 bl-responsive-stores"
              style="margin-top: 24px"
            >
              <Store
                v-for="store in stores"
                :key="store.id"
                :nameStore="store.pageName"
                :idStore="store.id"
                :isChecked="storeIsChecked(store.instaPageId)"
                @clickStore="
                  (checked, id) =>
                    isSelected(checked, id, store.instaPageId, store.pageName)
                "
              />
            </div>
            <Pagination
              :count="totalStores"
              :offset="offset"
              @firstPage="pagination('clickFirstPage')"
              @previousPage="pagination('clickPreviousPage')"
              @nextPage="pagination('clickNextPage')"
              @lastPage="pagination('clickLastPage')"
              :limit="3"
            /> -->

            <div class="d-flex flex-column mt-4">
              <Accordion :title="'Regionais'" v-if="nameToSearch.length === 0">
                <SubAccordion
                  :title="Rstore[0].regionalName"
                  :id="`${Rstore.id}`"
                  v-for="Rstore in Rstores"
                  :key="Rstore.id"
                  @selectAll="(regional) => selectAllRegional(regional)"
                >
                  <AccordionItem
                    v-for="store in Rstore"
                    :key="store.id"
                    :item="store"
                    :selected="storeIsChecked(store.instaPageId)"
                    @filter="
                      (checked) =>
                        isSelected(
                          checked,
                          store.id,
                          store.instaPageId,
                          store.pageName
                        )
                    "
                  />
                </SubAccordion>
              </Accordion>
              <Accordion
                :title="'Lojas'"
                :stores="true"
                @selectAll="selectAll(stores)"
              >
                <AccordionItem
                  v-for="store in stores"
                  :key="store.id"
                  :item="store"
                  :selected="storeIsChecked(store.instaPageId)"
                  @filter="
                    (checked) =>
                      isSelected(
                        checked,
                        store.id,
                        store.instaPageId,
                        store.pageName
                      )
                  "
                />
              </Accordion>
            </div>
          </div>

          <div class="w-100" v-show="step === 1">
            <span>
              <h3
                style="
                  font-style: normal;
                  font-weight: 700;
                  font-size: 34px;
                  color: var(--grey-medium);
                "
              >
                Escolha quando deverá ser publicado
              </h3>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  color: var(--black-medium);
                "
              >
                Escolha se a publicação deverá ser postada imediatamente ou em
                data agendada
              </p>
            </span>
            <section>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  color: var(--black-medium);
                "
              >
                Imediatamente
              </p>
              <div class="forToday">
                <label for="selectForToday">Fazer a publicação agora</label>
                <input
                  type="checkbox"
                  name=""
                  checked="checked"
                  id="selectForToday"
                  @click="clickForToday()"
                  style="border-radius: 100%"
                />
              </div>
              <p
                style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  color: var(--black-medium);
                "
              >
                Agendar
              </p>
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <v-date-picker
                    v-if="!isForToday"
                    v-model="post.date"
                    mode="date"
                    :columns="2"
                    :min-date="new Date()"
                    :max-date="maxMonth"
                    :locale="{
                      firstDayOfWeek: 2,
                      masks: { weekdays: 'WWW', title: 'MMMM' },
                    }"
                    style="
                      margin-bottom: 8px;
                      border: none;
                      background-color: var(--blue-light);
                      z-index: 0;
                    "
                    @dayclick="clickForToday()"
                  />
                  <v-date-picker
                    v-else
                    v-model="post.date"
                    mode="date"
                    :columns="2"
                    :disabled-dates="true"
                    :locale="{
                      firstDayOfWeek: 2,
                      masks: { weekdays: 'WWW', title: 'MMMM' },
                    }"
                    style="
                      margin-bottom: 8px;
                      border: none;
                      background-color: var(--blue-light);
                      z-index: 0;
                    "
                  />
                  <select
                    v-model="post.time"
                    style="margin-bottom: 22px; outline: none"
                    class="form-select"
                    @change="clickForToday()"
                    :disabled="isForToday"
                  >
                    <option value="" disabled selected>Horário</option>
                    <option
                      v-for="(option, index) in options"
                      :selected="option == post.time"
                      :key="index"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>
            </section>
          </div>

          <div class="w-100" v-show="step === 2">
            <div v-show="!publish">
              <span>
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Configure a sua postagem
                </h3>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--black-medium);
                  "
                >
                  Adicione fotos, videos, hashtags, descrição que a sua
                  publicação deverá ter.
                </p>
              </span>
              <section>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--black-medium);
                    margin-bottom: 0;
                  "
                >
                  Foto e Vídeo
                </p>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: #ff0000;
                  "
                >
                  <i>Formatos permitidos: jpeg, mp4, mov</i>
                </p>
                <p
                  v-if="isErrorGetter.erro"
                  style="color: #ff0000; font-size: 18px"
                >
                  Não foi possível realizar o seu agendamento, tente novamente
                  mais tarde.
                </p>
                <div
                  class="flex-column d-flex align-items-center justify-content-center w-100"
                  style="margin-bottom: 24px"
                >
                  <section
                    class="d-flex flex-wrap align-items-center w-100 justify-content-center"
                  >
                    <div
                      v-for="midia in midias"
                      :key="midia.id"
                      style="margin: 11.5px; position: relative"
                    >
                      <img
                        v-if="
                          !(
                            midia.type === 'video/mp4' ||
                            midia.type === 'video/quicktime' ||
                            midia.type === 'video/mov'
                          )
                        "
                        v-bind:ref="'image' + midia.id"
                        class="preview"
                        width="150"
                        height="150"
                        alt=""
                        style="border-radius: 8px"
                      />
                      <video
                        v-if="
                          midia.type === 'video/mp4' ||
                          midia.type === 'video/quicktime' ||
                          midia.type === 'video/mov'
                        "
                        v-bind:ref="'video' + midia.id"
                        class="preview"
                        width="350"
                        height="250"
                        alt=""
                        style="border-radius: 8px"
                        controls
                      ></video>

                      <img
                        role="button"
                        @click="removeMidia(midia.id)"
                        style="
                          position: absolute;
                          right: 8px;
                          top: 8px;
                          cursor: pointer;
                        "
                        :src="require('@/assets/images/svg/ícone-lixeira.svg')"
                      />
                      <p
                        v-show="!approvedImage"
                        :id="'msgError' + midia.id"
                        style="
                          text-align: center;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 14px;
                          color: #ff0000;
                          width: 150px;
                        "
                      ></p>
                      <p
                        v-show="!approvedImage"
                        :id="'msgError' + midia.url"
                        style="
                          text-align: center;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 14px;
                          color: #ff0000;
                          width: 150px;
                        "
                      ></p>
                    </div>
                    <label
                      v-if="limitMultipleImages"
                      class="btnMultipleImages"
                      style="margin: 11.5px"
                      for="attach-image"
                    >
                      <img
                        :src="require('@/assets/images/svg/ícone-mais.svg')"
                        alt=""
                      />
                    </label>
                    <input
                      v-if="limitMultipleImages"
                      type="file"
                      multiple
                      accept="image/jpeg, video/mp4"
                      @change="onFileChange"
                      id="attach-image"
                    />
                  </section>
                  <label
                    v-if="!isMultipleImages"
                    class="btnNotMultipleImages"
                    for="attach-image"
                    >Escolher Mídia</label
                  >
                  <input
                    v-if="!isMultipleImages"
                    type="file"
                    multiple
                    accept=".jpeg, .mov, .mp4"
                    @change="onFileChange"
                    id="attach-image"
                  />
                </div>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--black-medium);
                  "
                >
                  Descrição
                </p>
                <textarea
                  v-model="container.caption"
                  placeholder="Escreva aqui sobre a sua postagem"
                  class="w-100"
                ></textarea>
              </section>
            </div>
            <div v-show="publish">
              <span>
                <h3
                  style="
                    font-style: normal;
                    font-weight: 700;
                    font-size: 34px;
                    color: var(--grey-medium);
                  "
                >
                  Tudo certo!
                </h3>
                <p
                  v-if="isForToday"
                  style="
                    max-width: 600px;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--black-medium);
                  "
                >
                  Publicação realizada com sucesso. Ela será publicada na conta
                  do instagram escolhida
                </p>
                <p
                  v-else
                  style="
                    max-width: 600px;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    color: var(--black-medium);
                  "
                >
                  A sua publicação foi agendada com sucesso. No dia e hora
                  escolhidos ela será publicado na conta do instagram escolhida
                </p>
              </span>
              <SelectedStore :storeName="onlySelectedStore" />
              <section>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--black-medium);
                    margin-top: 1rem;
                  "
                >
                  Foto e Vídeo
                </p>
                <div
                  class="d-flex align-items-center flex-wrap justify-content-center"
                >
                  <div
                    v-for="(file, key) in midias"
                    :key="key"
                    style="margin: 11.5px; position: relative"
                  >
                    <img
                      v-if="file.type === 'image/jpeg'"
                      :src="file.midia"
                      width="64"
                      height="64"
                      alt=""
                      style="border-radius: 8px"
                    />
                    <video
                      v-if="
                        file.type === 'video/mp4' ||
                        file.type === 'video/mov' ||
                        file.type === 'video/quicktime'
                      "
                      :src="file.src_video"
                      width="64"
                      height="64"
                      alt=""
                      style="border-radius: 8px"
                    ></video>
                  </div>
                </div>
                <p
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--black-medium);
                  "
                >
                  Descrição
                </p>
                <textarea v-model="container.caption" class="w-100" readonly>
                </textarea>
                <div
                  id="footer-date-time"
                  class="w-100 d-flex align-items-center"
                >
                  <Input
                    space="date"
                    :inputValue="ptBRdateFormat"
                    :inputType="'text'"
                    :inputLabel="'Data'"
                    :inputTypeNotValidation="true"
                    :disabled="true"
                    :justView="true"
                  />
                  <Input
                    space="time"
                    :inputValue="post.time != '' ? post.time : ptBRTimeFormat"
                    :inputType="'text'"
                    :inputLabel="'Horário'"
                    :inputTypeNotValidation="true"
                    :disabled="true"
                    :justView="true"
                  />
                </div>
              </section>
            </div>
          </div>
          <footer
            class="w-100 d-flex justify-content-end"
            style="margin-top: 22px"
          >
            <button
              @click.prevent="backStep"
              v-if="!publish"
              type="button"
              class="btn-no-width btn-back col-12 col-sm-4"
              style="
                color: var(--blue-medium);
                background-color: var(--blue-light);
              "
            >
              Anterior
            </button>
            <button
              v-if="step < 2 && !publish"
              @click.prevent="nextStep"
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4"
              style="color: var(--white)"
            >
              Próximo
            </button>
            <button
              v-if="step == 2 && !publish"
              @click.prevent="savePost"
              type="button"
              :disabled="isDisabled || fileLarge"
              :class="isDisabled || fileLarge ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4"
              style="color: var(--white)"
            >
              Salvar
            </button>
            <router-link
              v-if="step == 2 && publish"
              :to="{ name: 'Posts' }"
              type="button"
              :disabled="isDisabled"
              :class="isDisabled ? 'able' : 'not-enabled'"
              class="btn-no-width btn-next col-12 col-sm-4 text-decoration-none text-center"
              style="color: var(--white)"
            >
              Fechar
            </router-link>
          </footer>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      data-bs-backdrop="false"
      id="modalViewSelectedStores"
      tabindex="1"
      aria-labelledby="modalViewSelectedStores"
      aria-hidden="true"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body table-responsive w-100">
            <table class="table align-middle">
              <tbody>
                <tr v-for="(name, index) in nameOfSelectedStores" :key="index">
                  <td>
                    <img
                      :src="require('@/assets/images/svg/ícone-loja.svg')"
                      alt=""
                      style="margin-right: 10px"
                    />
                  </td>
                  <td>{{ name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <Modal :showModal="notAllowedType">
      <form
        class="modal-dialog modal-dialog-centered"
        @submit.prevent="deletar"
      >
        <div
          class="modal-content"
          style="
            border-top: 8px solid var(--red-medium);
            max-width: 385px;
            padding: 8%;
          "
        >
          <div class="modal-header border-0 pb-0"></div>
          <div class="modal-body mt-0 pt-0">
            <h6
              class="modal-title d-inline-block mb-3"
              id="modalSelectedStoreLabel"
              style="font-style: normal; font-weight: 700; font-size: 18px"
            >
              Tipo de arquivo não suportado!
            </h6>
            <p
              style="
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 200;
                font-size: 16px;
                line-height: 19px;
                color: #80848a;
              "
            >
              Por favor, verifique os tipos de arquivos que estão sendo
              enviados!
              <span> Tipos suportados: </span>
              <br />
              <span class="text-danger font-weight-bold">.JPEG</span>
              para imagem,
              <span class="text-danger font-weight-bold">.MP4/.MOV</span> para
              vídeos.
            </p>
          </div>
          <div
            class="d-flex w-100 justify-content-center align-items-center"
            style="padding: 12px"
          >
            <button
              @click="isValidType"
              type="button"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: var(--blue-light);
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Ok
            </button>
          </div>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
import StepProgress from "../components/StepProgress.vue";
import SelectedStore from "@/components/SelectedStore.vue";
import InputSearch from "../components/InputSearch.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import apiGerenciarMidias from "../service/apiGerenciarMidiasService";
import Loading from "vue-loading-overlay";
import Input from "@/components/Input.vue";
import { v1 as uuidv1 } from "uuid";

import Accordion from "@/components/ui/accordion/accordion.vue";
import AccordionItem from "@/components/ui/accordion/accordionItem.vue";
import SubAccordion from "@/components/ui/accordion/subAccordion.vue";
import Modal from "@/components/ui/modal/modal.vue";
export default {
  components: {
    StepProgress,
    Accordion,
    AccordionItem,
    SubAccordion,
    InputSearch,
    Loading,
    SelectedStore,
    Input,
    Modal,
  },
  name: "NewPost",
  data() {
    return {
      post: {
        storeSelected: [],
      },
      container: {
        caption: "",
        mediaType: "",
        instaPageId: "",
        mediasContainers: [
          {
            flagCarousel: 0,
            mediaUrl: "",
          },
        ],
      },
      mystep: ["Loja", "Configuração", "Publicação"],
      stores: [],
      Rstores: {},
      midias: [],
      base64Midias: [],
      options: [],
      nameOfSelectedStores: [],
      step: 0,
      currentStep: 0,
      totalStores: 0,
      offset: 0,
      nameToSearch: "",
      typeMedia: "",
      isDisabled: true,
      isForToday: false,
      isLoading: false,
      approvedImage: true,
      publish: false,
      isImage: false,
      isBatch: true,
      notAllowedType: false,
      fileValidationType: [],
    };
  },
  watch: {
    handleStatusCode(payload) {
      if (payload === 200) {
        this.publish = true;
      }
    },
    isErrorGetter(payload) {
      if (payload.erro) {
        setTimeout(() => {
          this.isLoading = true;
        }, 9000);
        setTimeout(() => {
          this.hasError([]);
          this.currentStep = 0;
          this.isLoading = false;
        }, 10500);
      }
    },
    isLoadingPost(payload) {
      this.isLoading = payload;
    },
    getInstaMidiaContainer(arrayMidia) {
      this.isLoading = true;
      this.registerPostBatch(arrayMidia);
    },
    getInstaMidiaPosts(midiasPosts) {
      this.isLoading = true;

      if (midiasPosts.status === "fulfilled" || midiasPosts.status === 200) {
        this.publish = true;
      }

      this.isLoading = false;
    },
  },
  created() {
    this.isLoading = true;

    this.getStoresByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 3,
    }).then((response) => {
      this.stores = response.data.data;
      this.totalStores = response.data.count;

      response.data.groupedRegional.map((store) => {
        if (store.regional in this.Rstores) {
          // ok
        } else {
          this.Rstores[store.regional] = store.lojas;
        }
      });

      //fecha component loading
      this.isLoading = false;
    });

    this.intervalosNoDia(30).forEach((l) => {
      let option = `${String(l.getUTCHours()).padStart(2, "0")}:${String(
        l.getUTCMinutes()
      ).padStart(2, "0")}`;
      this.options.push(option);
    });
  },
  computed: {
    ...mapGetters([
      "getOffset",
      "getInstaMidiaContainer",
      "getInstaMidiaPosts",
      "isLoadingPost",
      "isErrorGetter",
      "handleStatusCode",
      "fileLarge",
    ]),
    isMultipleImages() {
      return this.midias.length > 0 ? true : false;
    },
    limitMultipleImages() {
      return this.midias.length > 0 && this.midias.length <= 9 && this.isImage
        ? true
        : false;
    },
    maxMonth() {
      let currentDate = new Date();
      return currentDate.setMonth(currentDate.getMonth() + 1);
    },
    onlySelectedStore() {
      return this.nameOfSelectedStores.length > 0 &&
        this.nameOfSelectedStores.length < 2
        ? this.nameOfSelectedStores[0]
        : "";
    },
    ptBRdateFormat() {
      let date =
        this.post.date != undefined ? new Date(this.post.date) : new Date();
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();

      return new Date(year, month, day).toLocaleDateString("pt-BR");
    },
    ptBRTimeFormat() {
      let date = this.post.time != "" ? "" : new Date();
      let hours = date != "" ? date.getHours() : this.post.time.substring(0, 2);
      let minutes =
        date != "" ? date.getMinutes() : this.post.time.substring(3);

      return `${hours}:${minutes}`;
    },

    isTypeFileValid() {
      return (
        this.fileValidationType == "jpeg" ||
        this.fileValidationType == "JPEG" ||
        this.fileValidationType == "mp4" ||
        this.fileValidationType == "MP4" ||
        this.fileValidationType == "mov"
      );
    },
  },

  methods: {
    ...mapActions([
      "getStoresByPagination",
      "getStoresByRegional",
      "uploadMediaToContainerBatch",
      "registerPostBatch",
      "isLoadingPostSet",
      "hasError",
      "setFile",
    ]),
    ...mapMutations(["SET_OFFSET"]),

    async onFileChange(e) {
      let typesVideo = ["video/mp4", "video/quicktime", "video/mov"];
      let typeImage = ["image/jpeg"];

      console.log("target files", e.target.files);

      if (
        e.target.files[0].type == "video/mp4" ||
        e.target.files[0].type == "video/mov"
      ) {
        if (e.target.files[0].size > 200000000) {
          this.setFile(true);
          alert(
            "Este arquivo não pode ser enviado porque excede o tamanho máximo permitido (200 MB)"
          );
        } else {
          this.setFile(false);
        }
      }

      for (let i = 0; i < e.target.files.length; i++) {
        let getTypesFiles = e.target.files[i].name.split(".");
        this.fileValidationType = getTypesFiles[getTypesFiles.length - 1];
      }

      if (this.isTypeFileValid) {
        for (let i = 0; i < e.target.files.length; i++) {
          let el = e.target.files[i];
          if (
            typesVideo.includes(el.type) &&
            i === 0 &&
            this.midias.length === 0
          ) {
            this.isImage = false;
            const id = uuidv1();
            this.midias.push({
              id: id,
              type: el.type,
              midia: undefined,
              url: "",
              file: el,
              src_video: undefined,
            });

            let reader = new FileReader();
            reader.addEventListener(
              "load",
              async function () {
                let buffer = reader.result;

                const videoBlob = new Blob([new Uint8Array(buffer)], {
                  type: el.type,
                });
                const videoBase64 = await this.blobToBase64(videoBlob);
                const url = window.URL.createObjectURL(videoBlob);

                this.midias.filter((item, index) => {
                  if (item.id === id) {
                    this.midias[index].src_video = url;
                    this.midias[index].midia = videoBase64;
                  }
                });
                this.$refs["video" + id][0].src = url;
              }.bind(this),
              false
            );

            reader.readAsArrayBuffer(el);
          } else if (typeImage.includes(el.type)) {
            this.isImage = true;
            const id = uuidv1();

            this.midias.push({
              id: id,
              type: el.type,
              midia: undefined,
              url: "",
              file: el,
            });

            let reader = new FileReader();

            reader.addEventListener(
              "load",
              function () {
                this.midias.filter((item, index) => {
                  if (item.id === id) {
                    this.midias[index].midia = reader.result;
                  }
                });
                this.$refs["image" + id][0].src = reader.result;
              }.bind(this),
              false
            );

            reader.readAsDataURL(el);
          }
        }
      } else {
        this.notAllowedType = true;
        this.$forceUpdate();
      }

      this.isDisabled = this.isMultipleImages ? false : true;
    },

    isValidType() {
      this.notAllowedType = false;
      this.$forceUpdate();
    },
    removeMidia(id) {
      for (let [i, file] of this.midias.entries()) {
        if (file.id === id) {
          this.midias.splice(i, 1);
        }
      }

      this.isDisabled = this.isMultipleImages ? false : true;
    },
    nextStep() {
      if (this.currentStep < this.mystep.length - 1) {
        this.currentStep++;
      }
      if (this.currentStep === 1) {
        this.clickForToday();
      } else {
        this.isDisabled = true;
        if (this.isMultipleImages) {
          this.isDisabled = false;
        }
      }
    },
    backStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    checkCurrentStep(val) {
      this.step = val;
    },
    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },
    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 3,
      };

      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getStoresByPagination(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    isSelected(checked, id, instaPageId, storeName) {
      if (this.post.storeSelected.length > 0) {
        if (this.post.storeSelected.includes(instaPageId)) {
          if (!checked) {
            this.post.storeSelected.splice(
              this.post.storeSelected.indexOf(instaPageId),
              1
            );
            this.nameOfSelectedStores.splice(
              this.nameOfSelectedStores.indexOf(storeName),
              1
            );

            if (this.post.storeSelected.length === 0) this.isDisabled = true;
          }
        } else {
          this.isDisabled = false;
          this.post.storeSelected.push(instaPageId);
          this.nameOfSelectedStores.push(storeName);
        }
      } else {
        this.isDisabled = false;
        this.post.storeSelected.push(instaPageId);
        this.nameOfSelectedStores.push(storeName);
      }
    },

    selectAll(items) {
      let intArr = Array.from(this.post.storeSelected);
      const storesIds = items.map((store) => store.instaPageId);
      const storesName = items.map((store) => store.pageName);

      if (intArr.length === 0) {
        this.isDisabled = false;
        this.post.storeSelected = storesIds;
        this.nameOfSelectedStores = storesName;
      } else if (intArr.length !== storesIds.length && intArr.length > 0) {
        this.post.storeSelected = [];
        this.nameOfSelectedStores = [];

        this.post.storeSelected = storesIds;
        this.nameOfSelectedStores = storesName;
      } else {
        this.isDisabled = true;
        this.post.storeSelected = [];
        this.nameOfSelectedStores = [];
      }
    },

    clickForToday() {
      this.isForToday = document.getElementById("selectForToday").checked;

      if (this.isForToday) {
        this.isDisabled = false;
      } else {
        if (this.post.time != "" && this.post.date != undefined) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      }
    },
    dateAndTimeFormatting() {
      let date = new Date(this.post.date);
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let hours = this.post.time.substring(0, 2);
      let minutes = this.post.time.substring(3);
      let mountedDateAndTime = new Date(year, month, day, hours, minutes, 0, 0);
      return mountedDateAndTime.toISOString();
    },
    intervalosNoDia(minutosPorIntervalo) {
      const minutes = 1000 * 60 * minutosPorIntervalo;
      const steps = (1000 * 60 * 60 * 24) / minutes;
      const lista = [];

      for (let step = 0; step < steps; step++) {
        lista.push(new Date(step * minutes));
      }

      return lista;
    },
    async uploadMidiaInService() {
      for (let [i, midia] of this.midias.entries()) {
        try {
          const response = await apiGerenciarMidias.uploadMedia(midia.file);
          if (response.status === 200) {
            midia.url = response.data;
          } else {
            this.approvedImage = false;
            document.getElementById("msgError" + midia.id).innerText =
              "Mídia recusada! Verifique se o formato é o permitido.";
            this.isLoading = false;
          }
        } catch (error) {
          this.approvedImage = false;
          document.getElementById("msgError" + midia.id).innerText =
            "Mídia recusada! Verifique se o formato é o permitido.";
          this.isLoading = false;
          return false;
        }
      }
    },

    async uploadMidiaInApiContainerBatch() {
      await this.uploadMediaToContainerBatch({
        midias: this.midias,
        container: this.container,
        post: this.post,
      });
    },

    async savePost() {
      this.isLoadingPostSet(true);
      await this.uploadMidiaInService();

      if (this.isForToday) {
        delete this.post.date, delete this.post.time;
      }

      for (let i = 0; i < this.midias.length; i++) {
        let getTypeMidia = this.midias[i].type.split("/");
        this.container.mediaType = getTypeMidia[0].toUpperCase();
      }

      let midia = this.midias.length;
      midia > 1
        ? (this.container.mediasContainers[0].flagCarousel = 1)
        : (this.container.mediasContainers[0].flagCarousel = 0);
      await this.uploadMidiaInApiContainerBatch();
    },
    async blobToBase64(blob) {
      return await new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    storeIsChecked(id) {
      if (this.post.storeSelected.includes(id)) {
        return true;
      } else {
        return false;
      }
    },
    selectAllRegional(regionalName) {
      const regional = this.Rstores[regionalName].map(
        (store) => store.instaPageId
      );
      const storesName = this.Rstores[regionalName].map(
        (store) => store.pageName
      );

      const has = regional.every((id) => this.post.storeSelected.includes(id));

      if (this.post.storeSelected.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }

      if (has) {
        regional.map((id) => {
          const index = this.post.storeSelected.indexOf(id);

          if (index !== -1) {
            this.post.storeSelected.splice(index, 1);
          }
        });

        storesName.map((name) => {
          const index = this.nameOfSelectedStores.indexOf(name);

          if (index !== -1) {
            this.nameOfSelectedStores.splice(index, 1);
          }
        });
      } else {
        this.post.storeSelected = [...this.post.storeSelected, ...regional];
        this.nameOfSelectedStores = [
          ...this.nameOfSelectedStores,
          ...storesName,
        ];
      }

      if (this.post.storeSelected.length > 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btnMultipleImages,
.btnNotMultipleImages {
  background-color: transparent;
  border: 1px solid var(--blue-medium);
  border-radius: 8px;
  color: var(--blue-medium);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  cursor: pointer;
  text-align: center;
}
.btnMultipleImages {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 150px;
}
.btn-back {
  margin-right: 8px;
}
.btn-next {
  margin-left: 8px;
}
.able {
  background-color: var(--grey-border);
}
.not-enabled {
  background-color: var(--blue-medium);
}
textarea {
  border: none;
  border-radius: 4px;
  padding: 12px 16px;
  background-color: var(--backgroundColor);
}
select {
  height: 48px;
  background-image: url("~@/assets/images/svg/ícone-seta-para-baixo-azul.svg") !important;
  background-color: var(--grey-light);
  border: none;
  color: var(--black-medium);
}
select:disabled {
  background-image: url("~@/assets/images/svg/ícone-seta-para-baixo-cinza.svg") !important;
  background-color: var(--grey-light);
  color: var(--grey-border);
}
select > option:checked {
  color: var(--black-medium);
}
select > option {
  color: var(--black-medium);
}
.forToday {
  background: var(--backgroundColor);
  border-radius: 4px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14.5px 16px;
  margin-bottom: 24px;
}
.time,
.date {
  margin-top: 1rem;
}
.time {
  margin-left: 8px;
}
.date {
  margin-right: 8px;
}
@media screen and (max-width: 563px) {
  .bl-responsive-stores {
    flex-direction: column;
  }
}
@media screen and (max-width: 576px) {
  footer {
    flex-direction: column;
  }
  .btn-back {
    margin-right: 0;
    margin-bottom: 8px;
  }
  .btn-next {
    margin-left: 0;
    margin-top: 8px;
  }
}
@media only screen and (max-width: 530px) {
  #footer-date-time {
    flex-direction: column;
  }
  .time {
    margin-left: 0;
  }
  .date {
    margin-right: 0;
  }
}
</style>
<style>
.form-select:focus {
  box-shadow: none !important;
}
</style>
